import { useState, useEffect, useMemo, useCallback } from 'react';
import { isMobile } from 'react-device-detect';
import "react-datepicker/dist/react-datepicker.css"
import { useParams } from 'react-router-dom';
import { Modal, Button } from "react-bootstrap"
import { LMSBASEURL } from '../../../config/apiUrls';
import Swal from 'sweetalert2';
import NoDataFound from '../../NoDataFound';
import PageHeader from '../../PageHeader';
import StudentAttendance from './student-attendance';
import StudentAttendance2 from './student-attendance2';
import { format } from 'date-fns';
import MarkSheetModal from '../../MarkSheetModal';
const formatDate = (date) => format(new Date(date), 'dd MMM yyyy, hh:mm a');

const InstituteStudentEnrollProgress = () => {
  const { id } = useParams();
  const [expandedCourse, setExpandedCourse] = useState(null)
  const [selectedQuiz, setSelectedQuiz] = useState(null)
  const [selectedModule, setSelectedModule] = useState(null)
  const [selectedAssignment, setSelectedAssignment] = useState(null)
  const [loading, setLoading] = useState(false)
  const [studentAttendaceData, setStudentAttendaceData] = useState([])
  const [studentEnrollmentData, setStudentEnrollmentData] = useState([])
  const [studentEnrollProgramModule, setStudentEnrollProgramModule] = useState({})
  const [loadingCourse, setLoadingCourse] = useState(null);
  const [quizLoadingQuizId, setQuizLoadingQuizId] = useState(null);
  const [quizLoadingModuleId, setQuizLoadingModuleId] = useState(null);
  const [quizLoadingAssignmentId, setQuizLoadingAssignmentId] = useState(null);
  const [showMarkSheetModal, setShowMarkSheetModal] = useState(false);

  const [studentInfo, setStudentInfo] = useState(null);

  const APItoken = process.env.REACT_APP_API_TOKEN;
  const AWS = process.env.REACT_APP_AWS_HOST;
  const instituteType = sessionStorage.getItem("instituteType")

  const lmsHeaders = {
    Authorization: APItoken,
    "Content-Type": "application/json",
    Accept: "application/json",
  };

  const AttendanceRaw = JSON.stringify({
    "id": id
  });

  const fetchAllStudentData = useCallback(async () => {
    if (!id) return console.warn("No student ID provided.");
    setLoading(true);

    try {
      const queries = [
        fetch(`${LMSBASEURL}/api/student/${id}`, { headers: lmsHeaders }),
        fetch(`${LMSBASEURL}/api/student/attendance`, { headers: lmsHeaders, body: AttendanceRaw, method: "POST" }),
        fetch(`${LMSBASEURL}/api/enrolledprogram?student_id=${id}&role=Student`, { headers: lmsHeaders }),
      ];
      const results = await Promise.allSettled(queries);

      const [studentProfileRes, studentAttendanceRes, studentEnrollRes] = results;

      let studentProfileData = [];
      let studentAttendanceData = [];
      let studentEnrollData = [];

      if (studentProfileRes.status === "fulfilled") {
        const data = await studentProfileRes.value.json();
        if (studentProfileRes.value.ok) {
          studentProfileData = data?.data || [];
        } else {
          console.error("Failed to load student:", data.message);
        }
      }

      if (studentAttendanceRes.status === "fulfilled") {
        const data = await studentAttendanceRes.value.json();
        if (studentAttendanceRes.value.ok) {
          studentAttendanceData = data?.data || [];
        } else {
          console.error("Failed to load attendance:", data.message);
        }
      }

      if (studentEnrollRes.status === "fulfilled") {
        const data = await studentEnrollRes.value.json();
        if (studentEnrollRes.value.ok) {
          studentEnrollData = data?.programs || [];
        } else {
          console.error("Failed to load enrollments:", data.message);
        }
      }

      setStudentInfo(studentProfileData);
      setStudentAttendaceData(studentAttendanceData);
      setStudentEnrollmentData(studentEnrollData);

    } catch (err) {
      console.error("Unexpected error fetching student data:", err.message);
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    fetchAllStudentData();
  }, [fetchAllStudentData]);

  const getStatusBadgeClass = (status) => {
    const classes = {
      'Active': 'bg-success text-white',
      'Graduate': 'bg-primary text-white',
      'Inactive': 'bg-secondary text-white'
    };
    return classes[status] || classes['Inactive'];
  };

  // const toggleExpand = async (programId) => {
  //   if (expandedCourse === programId) {
  //     setExpandedCourse(null);
  //     return;
  //   }

  //   if (studentEnrollProgramModule[programId]) {
  //     setExpandedCourse(programId);
  //     return;
  //   }

  //   try {
  //     setLoadingCourse(programId);

  //     const raw = JSON.stringify({
  //       student_id: id,
  //       course_id: programId,
  //     });

  //     const lmsHeaders = {
  //       Authorization: APItoken,
  //       "Content-Type": "application/json",
  //       Accept: "application/json",
  //     };

  //     const response = await fetch(`${LMSBASEURL}/api/student_progress`, {
  //       method: "POST",
  //       headers: lmsHeaders,
  //       body: raw,
  //     });

  //     const data = await response.json();
  //     if(response.status== 404){
  //       Swal.fire({
  //         icon: 'info',
  //         title: '',
  //         text: 'No course progress found for this student in the given program.',
  //         confirmButtonColor: '#eee127ff',
  //         confirmButtonText: 'OK'
  //       });
  //       return
  //     }
  //     if (!response.ok) {
  //       throw new Error(data.message || "We're having trouble loading data.");
  //     }

  //     setStudentEnrollProgramModule((prev) => ({
  //       ...prev,
  //       [programId]: data?.data || [],
  //     }));

  //     setExpandedCourse(programId);
  //   } catch (error) {
  //     setStudentEnrollProgramModule({});
  //     console.error("Error loading modules:", error);
  //   } finally {
  //     setLoadingCourse(null);
  //   }
  // };

  const toggleExpand = async (programId) => {
    if (expandedCourse === programId) {
      setExpandedCourse(null);
      return;
    }

    if (studentEnrollProgramModule[programId]) {
      setExpandedCourse(programId);
      return;
    }

    try {
      setLoadingCourse(programId);

      const raw = JSON.stringify({
        student_id: id,
        program_id: programId,
      });

      const lmsHeaders = {
        Authorization: APItoken,
        "Content-Type": "application/json",
        Accept: "application/json",
      };

      const response = await fetch(`${LMSBASEURL}/api/student-course-progress`, {
        method: "POST",
        headers: lmsHeaders,
        body: raw,
      });

      const data = await response.json();
      if (response.status == 404) {
        Swal.fire({
          icon: 'info',
          title: '',
          text: 'No course progress found for this student in the given program.',
          confirmButtonColor: '#eee127ff',
          confirmButtonText: 'OK'
        });
        return
      }
      if (!response.ok) {
        throw new Error(data.message || "We're having trouble loading data.");
      }

      setStudentEnrollProgramModule((prev) => ({
        ...prev,
        [programId]: data?.data || [],
      }));

      setExpandedCourse(programId);
    } catch (error) {
      setStudentEnrollProgramModule({});
      console.error("Error loading modules:", error);
    } finally {
      setLoadingCourse(null);
    }
  };

  const getProgressColor2 = (progress) => {
    if (progress >= 80) return "bg-success"
    if (progress >= 60) return "bg-info"
    if (progress >= 40) return "bg-warning"
    return "bg-danger"
  }

  const getProgressColor = (progress, isCourse = false) => {
    let bgClass = "bg-danger-subtle";
    let textClass = isCourse ? "text-danger" : "text-dark";

    if (progress >= 80) {
      bgClass = "bg-light-subtle";
      textClass = isCourse ? "text-success border-success-subtle border" : "text-dark";
    } else if (progress >= 60) {
      bgClass = isCourse ? '' : "bg-info-subtle";
      textClass = isCourse ? "text-info border-info-subtle border bg-none" : "text-dark";
    } else if (progress >= 40) {
      bgClass = "bg-warning-subtle";
      textClass = isCourse ? "text-warning" : "text-dark";
    } else if (progress >= 10 || progress == 0) {
      bgClass = "bg-danger-subtle";
      textClass = isCourse ? "text-danger" : "text-dark";
    }

    return `${bgClass} ${textClass}`;
  };

  const handleShowQuiz = async (quiz) => {
    if (!quiz?.course_id) {
      console.error("Missing course_id");
      return;
    }

    const requestOptions = {
      method: "POST",
      headers: {
        "Authorization": APItoken,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        student_id: id,
        course_id: quiz?.course_id,
      }),
    };

    try {
      setQuizLoadingQuizId(quiz.module_id);
      const response = await fetch(`${LMSBASEURL}/api/student/quiz-details`, requestOptions);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const result = await response.json();
      setSelectedQuiz(result?.data || []);
    } catch (error) {
      setSelectedQuiz([])
      console.error("Failed to fetch quiz details:", error);
    } finally {
      setQuizLoadingQuizId(null);
    }
  };

  const handleShowModule = async (quiz) => {
    if (!quiz?.course_id) {
      console.error("Missing course_id");
      return;
    }

    const requestOptions = {
      method: "POST",
      headers: {
        "Authorization": APItoken,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        student_id: id,
        course_id: quiz?.course_id,
      }),
    };

    try {
      setQuizLoadingModuleId(quiz.module_id);
      const response = await fetch(`${LMSBASEURL}/api/student_progress`, requestOptions);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const result = await response.json();
      setSelectedModule(result?.data || []);
    } catch (error) {
      setSelectedModule([])
      console.error("Failed to fetch quiz details:", error);
    } finally {
      setQuizLoadingModuleId(null);
    }
  };

  const handleShowAssignment = async (quiz) => {
    if (!quiz?.course_id) {
      console.error("Missing course_id");
      return;
    }

    const requestOptions = {
      method: "GET",
      headers: {
        "Authorization": APItoken,
        "Content-Type": "application/json",
      },
      // body: JSON.stringify({
      //   student_id: id,
      //   course_id: quiz?.course_id,
      // }),
    };

    try {
      console.log("quiz", quiz)
      setQuizLoadingAssignmentId(quiz.module_id);
      const response = await fetch(`${LMSBASEURL}/api/get-student-assignments-details?student_id=${id}&course_id=${quiz?.course_id}`, requestOptions);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const result = await response.json();
      setSelectedAssignment(result?.data || []);
    } catch (error) {
      setSelectedAssignment([])
      console.error("Failed to fetch quiz details:", error);
    } finally {
      setQuizLoadingAssignmentId(null);
    }
  }

  const handleClose = () => {
    setSelectedQuiz(null)
    setSelectedModule(null)
    setSelectedAssignment(null)
  }


  return (
    <div>
      {loading ? <div className="py-4">
        <div className="d-flex justify-content-center align-items-center" style={{ height: "400px" }}>
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      </div> :
        <>
          <div className="col-12">
            <PageHeader title="Student Progress Summary"
              breadcrumbs={[
                { label: "Dashboard", path: "/institute-dashboard" },
                { label: "Student Enrollment", path: "/student-enrollment" },
                { label: "Student Progress", active: true }
              ]}
            />
          </div>

          <div className="card border rounded-4">
            {!studentInfo || studentInfo?.length == 0 ||
              <div className="card-header bg-gradient border-0 p-4" style={{
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
              }}>
                <div className="row align-items-center g-4">
                  <div className="col-auto">
                    <div className="position-relative">
                      <img
                        src={studentInfo?.profile_image != 'Not Available' ? `${AWS}${studentInfo?.profile_image}` : `https://ui-avatars.com/api/?name=${studentInfo?.first_name}+${studentInfo?.last_name}&background=ffffff&color=667eea&size=100&font-size=0.4&bold=true`}
                        alt={`${studentInfo?.first_name} ${studentInfo?.last_name}`}
                        className="rounded-circle border border-4 border-white shadow"
                        style={{ width: "85px", height: "85px", objectFit: "cover" }}
                      />
                      <span className="position-absolute bottom-0 end-0 bg-success rounded-circle border border-2 border-white d-flex align-items-center justify-content-center"
                        style={{ width: "24px", height: "24px" }}>
                        <i className="bi bi-check-lg text-white" style={{ fontSize: "12px" }}></i>
                      </span>
                    </div>
                  </div>

                  <div className="col">
                    <div className="text-dark">
                      <h2 className="fw-bold mb-1 text-dark">
                        {studentInfo?.first_name} {studentInfo?.last_name}
                      </h2>
                      {/* <p className="mb-3 opacity-75">
                    <i className="bi bi-person-badge me-2"></i>
                    Student ID: #{studentInfo?.user_id || "Not Found"}
                  </p> */}
 
                      <div className="d-flex flex-wrap gap-2">
                        {instituteType != 'school' &&
                          <span className={`badge rounded-pill px-2 py-2 d-flex align-items-center gap-2 ${getStatusBadgeClass(studentInfo?.degree_status)}`}>
                            <i className="bi bi-mortarboard"></i>
                            Degree: {studentInfo?.degree_status || "No Degree"}
                          </span>}
 
                        <span className={`${instituteType == 'school' && 'border'} badge bg-white text-dark rounded-pill px-3 py-2 d-flex align-items-center gap-2`}>
                          <i className="bi bi-graph-up text-success"></i>
                          <span className="fw-bold">{studentInfo?.profile_progress || 0}%</span>
                          <span>Profile Complete</span>
                        </span>
                      </div>
                    </div>
                  </div>
 
                  {studentEnrollmentData?.some(p => p.id == 83) && (
                    <div className="col-auto">
                      <button
                        className="btn btn-sm btn-primary text-white d-flex align-items-center gap-2"
                        onClick={() => setShowMarkSheetModal(true)}
                      >
                        <i className="bi bi-file-earmark-text-fill"></i>
                        View Marksheet
                      </button>
                    </div>
                  )}
                </div>
              </div>}

            <div className={`card-body p-4 ${!studentInfo || studentInfo?.length == 0 ? 'border-0' : "border-top"}`}>
              <h4 className="fw-bold text-dark mb-4 d-flex align-items-center">
                <i className="bi bi-person-lines-fill me-2 text-primary"></i>
                Contact Information
              </h4>

              <div className="row g-4">
                <div className="col-lg-4 col-md-6">
                  <div className="d-flex align-items-start">
                    <div className="flex-shrink-0">
                      <div className="bg-success bg-opacity-10 rounded p-2 me-2">
                        <i className="bi bi-envelope text-success"></i>
                      </div>
                    </div>
                    <div className="flex-grow-1">
                      <div className="text-muted small fw-semibold">Email Address</div>
                      <div className="fw-semibold text-dark">{studentInfo?.email || "No Email"}</div>
                    </div>
                  </div>
                </div>

                <div className="col-lg-4 col-md-6">
                  <div className="d-flex align-items-start">
                    <div className="flex-shrink-0">
                      <div className="bg-success bg-opacity-10 rounded p-2 me-3">
                        <i className="bi bi-telephone text-success"></i>
                      </div>
                    </div>
                    <div className="flex-grow-1">
                      <div className="text-muted small fw-semibold">Phone Number</div>
                      <div className="fw-semibold text-dark">{studentInfo?.contact_number || "Not Found"}</div>
                    </div>
                  </div>
                </div>

                <div className="col-lg-4 col-md-6">
                  <div className="d-flex align-items-start">
                    <div className="flex-shrink-0">
                      <div className="bg-info bg-opacity-10 rounded p-2 me-3">
                        <i className="bi bi-geo-alt text-info"></i>
                      </div>
                    </div>
                    <div className="flex-grow-1">
                      <div className="text-muted small fw-semibold">Location</div>
                      <div className="fw-semibold text-dark">
                        {studentInfo?.city_name || "No City"}, {studentInfo?.state_name || "No State"}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-lg-4 col-md-6">
                  <div className="d-flex align-items-start">
                    <div className="flex-shrink-0">
                      <div className="bg-warning bg-opacity-10 rounded p-2 me-3">
                        <i className="bi bi-house text-warning"></i>
                      </div>
                    </div>
                    <div className="flex-grow-1">
                      <div className="text-muted small fw-semibold">Address</div>
                      <div className="fw-semibold text-dark">{studentInfo?.address1 || "No Address Found"}</div>
                    </div>
                  </div>
                </div>

                <div className="col-lg-4 col-md-6">
                  <div className="d-flex align-items-start">
                    <div className="flex-shrink-0">
                      <div className="bg-purple bg-opacity-10 rounded p-2 me-3" style={{ backgroundColor: 'rgba(102, 126, 234, 0.1)' }}>
                        <i className="bi bi-people" style={{ color: '#667eea' }}></i>
                      </div>
                    </div>
                    <div className="flex-grow-1">
                      <div className="text-muted small fw-semibold">Parent/Guardian</div>
                      <div className="fw-semibold text-dark">{studentInfo?.parent_name || "Not Found"}</div>
                    </div>
                  </div>
                </div>

                <div className="col-lg-4 col-md-6">
                  <div className="d-flex align-items-start">
                    <div className="flex-shrink-0">
                      <div className="bg-danger bg-opacity-10 rounded p-2 me-3">
                        <i className="bi bi-telephone-plus text-danger"></i>
                      </div>
                    </div>
                    <div className="flex-grow-1">
                      <div className="text-muted small fw-semibold">Parent Contact</div>
                      <div className="fw-semibold text-dark">{studentInfo?.parent_mobile_number || "Not Found"}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="card border rounded-4 mt-1">
            <div className="card-header">
              <div className="row align-items-center">
                <div className="col-md-6">
                  <h4 className="mb-0 fw-bold text-dark">
                    <i className="bi bi-bar-chart-fill text-primary me-2"></i>
                    Enrolled Program
                  </h4>
                </div>
              </div>
            </div>

            <div className={`row ${isMobile ? 'g-2 p-2' : 'p-4'}`}>
              {!studentEnrollmentData || studentEnrollmentData?.length == 0 ? <NoDataFound isEnroll message='📘 This student is not enrolled in any program.' /> :
                <>
                  {studentEnrollmentData?.map((program) => {
                    const lessons = program?.total_courses;
                    const lessonProgress = program?.completed_courses;
                    const quizzes = program?.total_quiz_count;
                    const assignments = program?.total_assignments;
                    const completedAssignments = program.assignment_submitted;

                    return (
                      <div key={program.id} className="">
                        <div className={`card border ${program?.completionPercentageSchool >= 100 && "border-success-subtle border-2"} rounded-4`}>
                          <div className={`card-body pb-0 ${expandedCourse === program.id ? 'p-2' : 'p-3'}`}>
                            <div className="row g-1 align-items-stretch">
                              <div className="col-md-6 col-12 d-flex flex-column border rounded-3 p-3">
                                <h5 className="fw-bold text-dark mb-1">{program?.program_title}</h5>
                                <small className="text-muted mt-1">
                                  <i className="bi bi-clock me-1"></i> {program?.duration}
                                </small>
                                <div className="mt-1 mb-0">
                                  <div className="d-flex justify-content-between align-items-center mb-2">
                                    <span className="fw-semibold text-dark small">Overall Progress</span>
                                    <span className="fw-bold text-dark small">{program?.completionPercentageSchool}%</span>
                                  </div>
                                  <div className="progress" style={{ height: "8px" }}>
                                    <div
                                      className={`progress-bar ${program?.completionPercentageSchool >= 80 ? "bg-success-subtle" :
                                        program?.completionPercentageSchool >= 60 ? "bg-success" :
                                          program?.completionPercentageSchool >= 10 || program?.completionPercentageSchool == 0 ? 'bg-danger' :
                                            getProgressColor(program?.completionPercentageSchool)
                                        } 
                                progress-bar-striped progress-bar-animated`}
                                      style={{ width: `${program?.completionPercentageSchool}%` }}
                                    />
                                  </div>
                                </div>
                                {instituteType != "school" &&
                                  <small className="text-muted mb-3">
                                    {program?.completed_courses} of {program?.total_courses} courses completed
                                  </small>}
                              </div>

                              <div className="col-md-6 col-12">
                                <div className="row g-1">
                                  <div className='row g-1'>
                                    <div className='col-4'></div>
                                    <div className='col-12 col-md-4'>
                                      <div className={`${getProgressColor(program?.completionPercentageSchool, true)} rounded-3 p-2 text-center`}>
                                        <div className="fs-6 fw-bold">{program?.completed_courses}/{lessons}</div>
                                        <small className="text-md fs-6">Total Course</small>
                                      </div>
                                    </div>
                                    <div className='col-4'></div>
                                  </div>
                                  <div className={`col-12 ${assignments == 0 ? 'col-md-6' : 'col-md-4'}`}>
                                    <div className={`${getProgressColor(program?.completionPercentageSchool, true)} rounded-3 p-2 text-center`}>
                                      <div className="fs-6 fw-bold">
                                        {program?.completed_chapters}/{program?.total_chapters}
                                      </div>
                                      <small className="text-md fs-6">Total Video</small>
                                    </div>
                                  </div>
                                  <div className={`col-12 ${assignments == 0 ? 'col-md-6' : 'col-md-4'}`}>
                                    <div className={`${getProgressColor(program?.completionPercentageSchool, true)} rounded-3 p-2 text-center`}>
                                      <div className="fs-6 fw-bold">{program?.quiz_submitted}/{quizzes}</div>
                                      <small className="text-md fs-6">Total Quizzes</small>
                                    </div>
                                  </div>
                                  {assignments != 0 &&
                                    <div className={`col-12 ${assignments == 0 ? 'col-md-6' : 'col-md-4'}`}>
                                      <div className={`${getProgressColor(program?.completionPercentageSchool, true)} rounded-3 p-2 text-center`}>
                                        <div className="fs-6 fw-bold">{program?.assignment_submitted}/{assignments}</div>
                                        <small className="text-md fs-6">Assignments</small>
                                      </div>
                                    </div>}
                                </div>
                              </div>

                              <div className="mt-4 text-center d-flex justify-content-center gap-2 flex-wrap">
                                <button
                                  className="btn btn-outline-primary btn-sm px-3 mb-2"
                                  onClick={() => toggleExpand(program.id)}
                                >
                                  {expandedCourse === program.id ? (
                                    <>
                                      <i className="bi bi-chevron-up me-1"></i> Hide Courses
                                    </>
                                  ) : (
                                    <>
                                      <i className="bi bi-chevron-down me-1"></i>
                                      {loadingCourse === program.id ? "Loading Courses..." : "View Courses"}
                                    </>
                                  )}
                                </button>
                                {program.id == 83 && (
                                  <button
                                    className="btn btn-info btn-sm px-3 mb-2 text-white"
                                    onClick={() => setShowMarkSheetModal(true)}
                                  >
                                    <i className="bi bi-file-earmark-text-fill me-1"></i>
                                    View Marksheet
                                  </button>
                                )}
                              </div>

                              {expandedCourse === program.id && (
                                <div className="mt-2 pt-1 rounded-bottom-4  coursefillcolor">
                                  <h5 className="fw-bold mb-3 text-dark m-2">Course List</h5>
                                  <div className="row g-3 p-1">
                                    {studentEnrollProgramModule[program?.id]?.map((course) => {
                                      const hasAssignments =
                                        course?.total_assignments != null &&
                                        !isNaN(course.total_assignments) &&
                                        course.total_assignments > 0;
                                      const completion = Number(course.completion_percentage);
                                      const colorClass = completion === 100 ? "text-success" : completion >= 50 ? "text-success" : "text-danger";

                                      return (
                                        <div key={course.course_id} className="col-12 col-lg-6">
                                          <div className="card shadow-sm border-warning border-2 rounded-4 mb-2">
                                            <div className="card-body">

                                              <div className="d-flex justify-content-between align-items-start mb-3 gap-2"
                                                style={{ flexDirection: isMobile ? "column" : "row" }}
                                              >
                                                <div className="flex-grow-1 text-truncate" title={course.course_name}>
                                                  <h6 className="fw-semibold text-dark mb-0 text-wrap">
                                                    {course.course_name}
                                                  </h6>
                                                </div>
                                              </div>
                                              <div className={`d-flex flex-shrink-0 gap-2 mb-1 w-100 justify-content-center`}>
                                                <button
                                                  className="btn btn-primary btn-sm text-nowrap "
                                                  onClick={() => handleShowQuiz(course)}
                                                >
                                                  {quizLoadingQuizId === program.id ? "Loading..." : "Quiz Details"}
                                                </button>
                                                <button
                                                  className="btn btn-primary btn-sm text-nowrap"
                                                  onClick={() => handleShowModule(course)}
                                                >
                                                  {quizLoadingModuleId === program.id ? "Loading..." : "View Modules"}
                                                </button>
                                                {hasAssignments &&
                                                  <button
                                                    className="btn btn-primary btn-sm text-nowrap"
                                                    onClick={() => handleShowAssignment(course)}
                                                  >
                                                    {quizLoadingAssignmentId === program.id ? "Loading..." : "View Assignments"}
                                                  </button>}
                                              </div>

                                              <div className="mb-3">
                                                <div className="d-flex justify-content-between align-items-center mb-1">
                                                  <small className="text-muted">Completion Progress</small>
                                                  <small className="fw-semibold">{completion.toFixed(0)}%</small>
                                                </div>
                                                <div className="progress" style={{ height: "6px" }}>
                                                  <div
                                                    className={`progress-bar ${completion >= 75
                                                      ? "bg-success"
                                                      : completion >= 40
                                                        ? "bg-warning"
                                                        : "bg-danger"
                                                      }`}
                                                    style={{ width: `${completion}%` }}
                                                  ></div>
                                                </div>
                                              </div>

                                              <div className="row text-center g-2">
                                                <div className={hasAssignments ? "col-4" : "col-6"}>
                                                  <div className="border border-warning rounded-3 py-2">
                                                    <div className={`fw-bold ${colorClass}`}>
                                                      {course.completed_chapters}/{course.total_chapters}
                                                    </div>
                                                    <div className="small text-muted">Video Completed</div>
                                                  </div>
                                                </div>

                                                <div className={hasAssignments ? "col-4" : "col-6"}>
                                                  <div className="border border-warning rounded-3 py-2">
                                                    <div className={`fw-bold ${colorClass}`}>
                                                      {course.completed_quizzes}/{course.total_quizzes}
                                                    </div>
                                                    <div className="small text-muted">Quizzes Completed</div>
                                                  </div>
                                                </div>
                                                {course?.total_assignments != null &&
                                                  !isNaN(course.total_assignments) &&
                                                  course.total_assignments > 0 &&
                                                  <div className={hasAssignments ? "col-4" : "col-6"}>
                                                    <div className="border border-warning rounded-3 py-2">
                                                      <div className={`fw-bold ${colorClass}`}>
                                                        {course.completed_assignments}/{course?.total_assignments}
                                                      </div>
                                                      <div className="small text-muted">Assignments Completed</div>
                                                    </div>
                                                  </div>}
                                              </div>

                                            </div>
                                          </div>
                                        </div>
                                      );
                                    })}
                                  </div>

                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </>
              }
            </div>
          </div>

          {/* Weekly Graph */}
          {instituteType == "school" ?
            <StudentAttendance2
              attendanceData={studentAttendaceData}
            /> :
            <StudentAttendance
              attendanceData={studentAttendaceData}
            />}

        </>}
      <MarkSheetModal
        show={showMarkSheetModal}
        onHide={() => setShowMarkSheetModal(false)}
        student={{
          id: id,
          name: studentInfo?.first_name + " " + studentInfo?.last_name,
          ...studentInfo
        }}
      />
      <Modal
        show={!!selectedQuiz}
        onHide={handleClose}
        centered
        size="lg"
        dialogClassName="modal-dialog-scrollable"
      >
        <Modal.Header closeButton>
          <Modal.Title className="fw-bold text-primary">
            📋 Quiz Details
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0">

          {selectedQuiz && selectedQuiz.length > 0 ? (
            <>
              <div className="table-responsive d-none d-md-block p-3">
                <table className="table table-hover align-middle mb-0">
                  <thead className="table-light">
                    <tr>
                      <th className="text-center">#</th>
                      <th>Title</th>
                      <th className="text-center">Status</th>
                      <th className="text-center">Type</th>
                      <th className="text-center">Score</th>
                      <th className="text-center">Passing grade(%)</th>
                      <th className="text-center">Retakes</th>
                    </tr>
                  </thead>
                  <tbody>
                    {selectedQuiz.map((quiz, idx) => {
                      return (
                        <tr key={quiz.quiz_id}>
                          <td className="text-center">{idx + 1}</td>
                          <td className="fw-semibold">
                            {quiz.quiz_title}
                            {quiz.type === "exam" && (
                              <span className="ms-2 badge bg-info">Exam</span>
                            )}
                          </td>
                          <td className="text-center">
                            {quiz.result_status === "passed"
                              ?
                              <span
                                className={`badge bg-success ${quiz.result_status === "passed"
                                  ? "bg-success"
                                  : "bg-danger"
                                  }`}
                              >
                                {quiz.result_status === "passed"
                                  ? "Passed"
                                  : quiz.result_status === ""
                                    ? "-"
                                    : "Failed"}
                              </span>
                              : quiz.result_status === ""
                                ? "-"
                                : <span
                                  className={`badge bg-danger ${quiz.result_status === "passed"
                                    ? "bg-success"
                                    : "bg-danger"
                                    }`}
                                >
                                  {quiz.result_status === "passed"
                                    ? "Passed"
                                    : quiz.result_status === ""
                                      ? "-"
                                      : "Failed"}
                                </span>
                            }

                          </td>
                          <td className="text-center text-capitalize">{quiz.type}</td>
                          <td className="text-center">
                            <span
                              className={`fw-bold ${parseFloat(quiz.percentage_score) >= 70
                                ? "text-success"
                                : "text-danger"
                                }`}
                            >
                              {quiz.achieved_points}/{quiz.total_points}
                            </span>
                            {quiz.type == "exam" && <><br /><span className={`small ${parseFloat(quiz.percentage_score) >= 70
                              ? "text-success"
                              : "text-danger"
                              }`}>{quiz?.percentage_score?.slice(0, -3)}%</span> </>}
                          </td>
                          <td className="text-center text-muted">
                            {quiz.type != "quiz" ? <>{Math.round(quiz.total_points * 0.7)}</> : "-"}
                          </td>
                          <td className="text-center text-info">
                            {quiz.student_retake_count}/{quiz.quiz_retake_count}
                          </td>
                        </tr>
                      )
                    })}
                  </tbody>
                </table>
              </div>

              <div className="d-block d-md-none p-3">
                {selectedQuiz.map((quiz, idx) => (
                  <div key={quiz.quiz_id} className="card mb-3 shadow-sm border-0 rounded-3">
                    <div className="card-body position-relative">

                      <span
                        className={`badge rounded-pill position-absolute top-0 end-0 m-2 px-3 py-2 ${quiz.result_status === "passed"
                          ? "bg-success"
                          : "bg-danger"
                          }`}
                      >
                        Status: {quiz.result_status === "passed"
                          ? "Passed"
                          : quiz.result_status === ""
                            ? "Not Found"
                            : "Failed"}
                      </span>

                      <h6 className="card-title fw-bold text-primary mb-2">
                        {idx + 1}. {quiz.quiz_title}
                        {quiz.type === "exam" && (
                          <span className="ms-2 badge bg-info">Exam</span>
                        )}
                      </h6>

                      <div className="small text-muted">
                        <p className="mb-1">
                          <strong>Type:</strong>{" "}
                          <span className="text-capitalize">{quiz.type}</span>
                        </p>

                        <p className="mb-1">
                          <strong>Score:</strong>{" "}
                          <span
                            className={`fw-bold ${parseFloat(quiz.percentage_score) >= 70
                              ? "text-success"
                              : "text-danger"
                              }`}
                          >
                            {quiz.achieved_points}/{quiz.total_points}
                          </span>
                        </p>

                        <p className="mb-1">
                          <strong>Passing:</strong>{" "}
                          {Math.round(quiz.total_points * 0.7)}
                        </p>

                        <p className="mb-0">
                          <strong>Retakes:</strong>{" "}
                          <span className="text-info">{quiz.quiz_retake_count}</span>
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

            </>
          ) : (
            <div className="text-center py-5">
              <i className="bi bi-clipboard-x fs-1 text-muted mb-3"></i>
              <h5 className="fw-bold text-muted">No quizzes available</h5>
              <p className="text-muted mb-0">
                There are currently no quiz details to display.
              </p>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-end border-top-0">
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={!!selectedModule}
        onHide={handleClose}
        centered
        size="xl"
        dialogClassName="modal-dialog-scrollable"
      >
        <Modal.Header closeButton>
          <Modal.Title className="fw-bold text-primary">
            📋 Module Details
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0">

          {selectedModule && selectedModule.length > 0 ? (
            <>
              <div className="table-responsive p-2">
                <table className="table table-bordered align-middle">
                  <thead className="table-warning text-center">
                    <tr>
                      <th>Module Title</th>
                      <th>Completed Video</th>
                      <th>Total Video</th>
                      <th>Completed Quizzes</th>
                      <th>Total Quizzes</th>
                      {/* <th>Action</th> */}
                    </tr>
                  </thead>

                  <tbody>
                    {selectedModule?.map((module) => {
                      return (
                        <tr key={module.module_id}>
                          <td className="fw-semibold">{module.module_title}</td>
                          <td className="text-center">{module.completed_chapters}</td>
                          <td className="text-center">{module.total_chapters}</td>
                          <td className="text-center">{module.completed_quizzes}</td>
                          <td className="text-center">{module.total_quizzes}</td>
                          {/* <td className="text-center">
                          <button
                            className="btn btn-primary btn-sm"
                            onClick={() => handleShowQuiz(module, program.id)}
                          >
                            {quizLoadingModuleId === module.module_id ? "Loading Quiz..." : "Quiz Details"}
                          </button>
                        </td> */}
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>

            </>
          ) : (
            <div className="text-center py-5">
              <i className="bi bi-clipboard-x fs-1 text-muted mb-3"></i>
              <h5 className="fw-bold text-muted">No module available</h5>
              <p className="text-muted mb-0">
                There are currently no module details to display.
              </p>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-end border-top-0">
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={!!selectedAssignment}
        onHide={handleClose}
        centered
        size="xl"
        dialogClassName="modal-dialog-scrollable"
      >
        <Modal.Header closeButton>
          <Modal.Title className="fw-bold text-primary">
            📋 Assignments Details
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0">

          {selectedAssignment && selectedAssignment?.length > 0 ? (
            <>
              <div className="table-responsive">
                <table className="table table-hover align-middle mb-0 table-bordered">
                  <thead className="bg-light text-dark">
                    <tr>
                      <th>Title</th>
                      <th className='text-center'>Submitted</th>
                      <th className='text-center'>Evaluated</th>
                      <th className='text-center'>Marks</th>
                      <th>Remark</th>
                    </tr>
                  </thead>
                  <tbody>
                    {selectedAssignment?.map(item => (
                      <tr key={item.assignment_id}>
                        <td className="fw-semibold text-primary">{item.assignment_title}</td>
                        <td >
                          {item.is_submitted ? (
                            <div className="d-flex flex-column align-items-center">
                              <span className="badge bg-success mb-1">Submitted</span>
                              <span className="text-muted small mt-1">
                                {formatDate(item.submitted_at)}
                              </span>
                            </div>
                          ) : (
                            <div className="d-flex flex-column align-items-center">
                              <span className="badge bg-danger">Not Submitted</span>
                            </div>
                          )}
                        </td>
                        <td>
                          {item.is_evaluation_submitted ? (
                            <div className="d-flex flex-column align-items-center text-start">
                              <span className="badge bg-success">Evaluated</span>
                              <span className="text-muted small mt-1">
                                {formatDate(item.evaluated_at)}
                              </span>
                            </div>
                          ) : (
                            <div className="d-flex flex-column align-items-center">
                              <span className="badge bg-danger">Not Evaluated</span>
                            </div>
                          )}
                        </td>
                        <td className="text-center fw-bold">
                          {item.assignment_marks ?? "0"}/{item.obtained_marks ?? "0"}
                        </td>
                        <td>{item.remark || "—"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

            </>
          ) : (
            <div className="text-center py-5">
              <i className="bi bi-clipboard-x fs-1 text-muted mb-3"></i>
              <h5 className="fw-bold text-muted">No Assignment available</h5>
              <p className="text-muted mb-0">
                There are currently no Assignments details to display.
              </p>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-end border-top-0">
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>


      <style>{`
        .course-card {
          
          border-radius: 16px;
          padding: 0;
          background: white;
          overflow: hidden;
        }
        
        .course-main-content {
          padding: 24px;
        }
        
        .left-box {
          border-radius: 12px;
          padding: 20px;
          height: 100%;
          min-height: 200px;
          display: flex;
          flex-direction: column;
        }
        
        .right-stats-container {
          display: flex;
          flex-direction: column;
          gap: 12px;
          height: 100%;
        }
        
        .stats-box {
          border-radius: 12px;
          padding: 16px;
          text-align: center;
          background: white;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
        }
        
        .stats-box-large {
          flex: 0 0 auto;
        }
        
        .stats-row {
          display: flex;
          gap: 12px;
          flex: 1;
        }
        
        .stats-box-small {
          flex: 1;
          min-height: 80px;
        }
        
        .stat-number {
          font-size: 1.25rem;
          font-weight: 600;
          color: #212529;
          margin-bottom: 4px;
        }
        
        .stat-label {
          font-size: 0.875rem;
          color: #212529;
        }
        
        .progress-section {
          margin-top: auto;
        }
        
        .progress-label {
          font-size: 0.875rem;
          color: #212529;
          margin-bottom: 8px;
        }
        
        .view-course-section {
          padding: 20px;
          text-align: center;
        }
        
        .view-course-btn {
          border-radius: 8px;
          padding: 10px 32px;
          background: white;
          color: #000;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.2s ease;
        }
        
        .view-course-btn:hover {
          background: #f8f9fa;
        }
        
        @media (max-width: 768px) {
          .stats-row {
            flex-direction: column;
          }
        }
      `}</style>

    </div>
  );
};

export default InstituteStudentEnrollProgress;
